import { workflowsRoute as route } from '@utils/consts';
import { ProtectedRoute } from '@components/protectedRoute';
import { Outlet } from 'react-router';

const detailsRoute = {
  path: route.workflow(),
  lazy: async () => {
    const { Workflow } = await import('@pages/panel/workflows/_id');
    return {
      Component: () => <Workflow />,
    };
  },
  children: [
    {
      path: route.workProgress,
      lazy: async () => {
        const { WorkflowWorkProgress } = await import('@pages/panel/workflows/_id/workProgress');
        return {
          Component: () => <WorkflowWorkProgress />,
        };
      },
    },
    {
      path: route.materials,
      lazy: async () => {
        const { WorkflowMaterials } = await import('@pages/panel/workflows/_id/materials');
        return {
          Component: () => <WorkflowMaterials />,
        };
      },
    },
    {
      path: route.questionnaires,
      lazy: async () => {
        const { WorkflowQuestionnaires } = await import(
          '@pages/panel/workflows/_id/questionnaires'
        );
        return {
          Component: () => <WorkflowQuestionnaires />,
        };
      },
    },
    {
      path: route.questionnaire(),
      lazy: async () => {
        const { QuestionnaireProvider } = await import('@contexts/panel/workflows/questionnaire');
        const { WorkflowQuestionnaire } = await import(
          '@pages/panel/workflows/_id/questionnaires/_id'
        );
        return {
          Component: () => (
            <QuestionnaireProvider>
              <WorkflowQuestionnaire />
            </QuestionnaireProvider>
          ),
        };
      },
    },
  ],
};

const routes = [
  {
    path: route.index,
    lazy: async () => {
      const { WorkflowsProvider } = await import('@contexts/panel/workflows');
      return {
        Component: () => (
          <ProtectedRoute panel>
            <WorkflowsProvider>
              <Outlet />
            </WorkflowsProvider>
          </ProtectedRoute>
        ),
      };
    },
    children: [
      {
        path: '',
        lazy: async () => {
          const { Workflows } = await import('@pages/panel/workflows');
          return {
            Component: () => <Workflows />,
          };
        },
      },
      detailsRoute,
    ],
  },
];

const jobRoutes = [
  {
    path: route.index,
    lazy: async () => {
      const { WorkflowsSourceProvider } = await import('@contexts/panel/workflows/source');
      const { WorkflowsProvider } = await import('@contexts/panel/workflows');
      return {
        Component: () => (
          <WorkflowsSourceProvider>
            <WorkflowsProvider>
              <Outlet />
            </WorkflowsProvider>
          </WorkflowsSourceProvider>
        ),
      };
    },
    children: [detailsRoute],
  },
];

export { routes as workflowsRoutes, jobRoutes as jobWorkflowsRoutes };
